import { useQuery } from "react-query";

import { calculationService } from "services";

type UseCalculationsListProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
};

const useCalculationsListQuery = ({
	fetchData,
	paidMonth,
	paidYear,
}: UseCalculationsListProps) => {
	const { page, filters, sortBy } = fetchData;

	const fetchList = () =>
		calculationService.getCalculationList({
			paidMonth,
			paidYear,
			page,
			filters,
			sortBy,
		});

	const queryResult = useQuery(
		["calculationsList", paidMonth, paidYear, page, filters, sortBy],
		fetchList,
		{
			retry: 0,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useCalculationsListQuery;
